module.exports = __webpack_public_path__ + "static/media/Moj-6.b520bfcf.PNG";